import glDialog from './glDialog';
import glPreviewImage from './glPreviewImage';
import glDialogQRCode from './glDialogQRCode';
import glInputDisabled from './glInputDisabled';
import glOperateMenu from './glOperateMenu';
import glTable from './glTable';
import glDrawer from './glDrawer';
import glImageViewer from './glImageViewer';
import glExplain from './glExplain';
import glSearchForm from './glSearchForm';
import glTooltip from './glTooltip';

export default {
  install: function(Vue) {
    Vue.component('gl-dialog', glDialog);
    Vue.component('gl-preview-image', glPreviewImage);
    Vue.component('gl-dialog-qr-code', glDialogQRCode);
    Vue.component('gl-input-disabled', glInputDisabled);
    Vue.component('gl-operate-menu', glOperateMenu);
    Vue.component('gl-table', glTable);
    Vue.component('gl-drawer', glDrawer);
    Vue.component('gl-explain', glExplain);
    Vue.component('gl-image-viewer', glImageViewer);
    Vue.component('gl-search-form', glSearchForm);
    Vue.component('gl-tooltip', glTooltip);
  },
};
